export const HideElementOnScrollEffectThreshold = {
  desktop: 548, // rest to 508 if sub nav ab test not taking the variant one
  mobile: 200,
};
